import { useAuth } from "../../../utils/useAuth";
import { Spin } from "antd";
import { Switch, Route, Redirect } from "react-router-dom";
import LayoutParticipanteHeader from "./LayoutParticipanteHeader";
import * as SHARED from "../../../utils/shared";

function LayoutIngresante({ routes }) {
  const { user, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (!user) return <Redirect to={SHARED.PATH_INICIO} />;

  if (isAdmin) return <Redirect to={SHARED.PATH_SISTEMA} />;

  return (
    <div className="flex flex-col w-full min-h-screen items-center justify-between">
      <LayoutParticipanteHeader user={SHARED.USUARIO.payload} />
      <main className="mb-auto w-full md:flex md:content-between">
        <aside className="w-full px-6">
          <LoadRoutes routes={routes} user={SHARED.USUARIO.payload} />
        </aside>
      </main>
      <footer className="py-8">
        <p className="text-center font-semibold text-xs text-gray-400">
          {SHARED.TITLE_SISTEMA_SHORT}
        </p>
      </footer>
    </div>
  );
}
export default LayoutIngresante;

/**
 * Carga las rutas definidas en el archivo de rutas.
 * @param {Array} routes
 */
function LoadRoutes(props) {
  const { routes, user } = props;
  return (
    <Switch>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          component={(props) => <route.component {...props} user={user} />}
        />
      ))}
    </Switch>
  );
}
